export default {
	mounted: function() {
		console.log("Offer modal mounted");
		
		let vm = this;
		setTimeout(function() {
			vm.$refs.offerModal.show()
		}, 3600)
	},
	methods: {
		hideModal: function() {
			this.$refs.offerModal.hide();
		}
	}
}


// WEBPACK FOOTER //
// ./src/common/Offer/offer.js